import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIcon } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ListDropDownComponent } from '@src/suite/common/components/list-drop-down/list-drop-down';

import { BaseViewOptionsComponent } from '../base-view-options.component';

@Component({
    selector: 'st-discover-view-options',
    imports: [ListDropDownComponent, MatButtonModule, MatButtonToggleModule, MatIcon, MatListModule, MatMenuModule, MatTooltipModule],
    templateUrl: './discover-view-options.component.html',
    styleUrl: './discover-view-options.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'st-discover-view-options',
    },
})
export class DiscoverViewOptionsComponent extends BaseViewOptionsComponent {}
